export const WATCHLIST_CAPTION = '###watchlist###system###'
